export enum PlatformJobsTab {
  RECOMMENDATIONS = 'recommendations',
  ALL = 'all',
  SAVED = 'saved',
  INVITATIONS = 'invitations',
}
